import { Record } from "immutable";

const LabelRecord = Record({
  id: 0,
  class: ``,
  name: ``,
  color: `#999`,
  lighter_text_color: ``,
  darker_text_color: ``,
  is_default: false,
  is_global: false,
  project_id: 0,
  position: 0,
  updated_on: 0,
});

class Label extends LabelRecord {}

export default Label;
